import { useContext, useEffect } from "react";

import { Container, Grid } from "@material-ui/core";
import Loading from "../../../components/basics/Loading";
import Btn from "../../../components/buttons/Btn";

import useDespesasReembolsaveisController from "./controllers/DespesasReembolsaveisController";
import AccordionDespesasDadosGerais from "./children/AccordionDespesasDadosGerais";
import HeaderModule from "../../../components/header/HeaderModule";
import { Margin } from "../../../theme/styles/Utils";
import {
  DespesasReembolsaveisContext,
  DespesasReembolsaveisContextProvider,
} from "./contexts/DespesasReembolsaveisContext";
import { Line } from "./styles/DespesasReembolsaveis";
import { GlobalVariables } from "../../../GlobalVariables";

const View = ({ location }) => {
  const { loading } = useContext(DespesasReembolsaveisContext);

  const { storeAndUpdate, back, handleSetData } =
    useDespesasReembolsaveisController();

  useEffect(() => {
    handleSetData(location?.state?.id);
  }, [location, handleSetData]);

  return (
    <>
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE DESPESAS REEMBOLSÁVEIS"
        videoId={GlobalVariables.screenVideosIds.cadastroDespesasReembolsaveis}
      />
      <Margin top="100">
        <Container maxWidth="xl">
          <AccordionDespesasDadosGerais />

          <Line container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Btn
                label="Voltar"
                hovercolor="darkred"
                bgcolor="tertiary"
                onClick={back}
              />
            </Grid>
            <Grid item>
              <Btn
                label="Salvar"
                onClick={() => {
                  storeAndUpdate();
                }}
              />
            </Grid>
            <Grid item>
              <Btn
                label="Salvar e Novo"
                onClick={() => {
                  storeAndUpdate(true);
                }}
              />
            </Grid>
          </Line>
        </Container>
      </Margin>
    </>
  );
};

const DespesasReembolsaveisCadastro = ({ ...props }) => {
  return (
    <DespesasReembolsaveisContextProvider>
      <View {...props} />
    </DespesasReembolsaveisContextProvider>
  );
};

export default DespesasReembolsaveisCadastro;
